import { AutogramFrequency, SelectableAutogramFrequency } from 'types';

export function isSelectableAutogramFrequency(
  frequency: AutogramFrequency,
): frequency is SelectableAutogramFrequency {
  return ['onPublish', 'fromFirstEpisode'].includes(frequency);
}
